import { DEFAULT_PAGE_SIZE } from '../constants';
import {
  DeliveryNoteHandlingUnitSearchCriteria,
  PlannerProfileListSearchCriteria,
  HubLoanerPhoneListSearchCriteria,
  HubFrequentDriverListSearchCriteria,
  AddressListSearchCriteria,
  ApiConnectionListSearchCriteria,
  CompartmentRuleListSearchCriteria,
  CompartmentAssignedUserListSearchCriteria,
  UserListSearchCriteria,
  NewsletterListSearchCriteria,
  OrganizationListSearchCriteria,
  PartnerListSearchCriteria,
  HandlingUnitMaterialSearchCriteria,
  MasterDataReportListSearchCriteria,
  MasterDataListSearchCriteria,
  HubListSearchCriteria,
  PlannerProfileBriefListSearchCriteria,
  CompartmentAvailableUserListSearchCriteria,
  Sc4FailedMessagesListSearchCriteria,
  ShipmentListSearchCriteria,
  PartnerSearchCriteria,
  EulaListSearchCriteria,
  Sc3FailedMessagesListSearchCriteria,
  ExportsListSearchCriteria,
  DemurrageDetentionSearchCriteria,
  TruckDriversSearchCriteria,
  UserDeletionHistoryListSearchCriteria,
  ShipmentWaybillGoodsItemListSearchCriteria,
  ShipmentWaybillMaterialListSearchCriteria,
  CouplingPlanSearchCriteria,
  YardSpotSearchCriteria,
} from '../../store';
import { ListQueryParam } from '../constants/list-query-param.constant';
import { PlantListSearchCriteria } from '../../store/state/administration/plant';
import { CountryListSearchCriteria } from '../../container-components/country-selection';

export interface BaseListStateModel {
  loaded: boolean;
}

export class ListObject<ItemType> {
  items: ItemType[] = [];
  size: number = null;
  pageNumber: number = null;
  numberOfElements: number = null;
  totalElements: number = null;
  totalPages: number = null;

  constructor(params?: ListObject<ItemType>) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export const DEFAULT_LIST_QUERY_PARAM_LIMIT = 10;

export class ListRange {
  [ListQueryParam.Size] = DEFAULT_PAGE_SIZE;
  [ListQueryParam.Page] = 0;
}

export class SearchCriteriaBase extends ListRange {}

export type SearchCriteria =
  | PlannerProfileListSearchCriteria
  | DeliveryNoteHandlingUnitSearchCriteria
  | ShipmentWaybillGoodsItemListSearchCriteria
  | ShipmentWaybillMaterialListSearchCriteria
  | HubLoanerPhoneListSearchCriteria
  | HubFrequentDriverListSearchCriteria
  | AddressListSearchCriteria
  | ApiConnectionListSearchCriteria
  | CompartmentRuleListSearchCriteria
  | CompartmentAssignedUserListSearchCriteria
  | CountryListSearchCriteria
  | UserListSearchCriteria
  | EulaListSearchCriteria
  | NewsletterListSearchCriteria
  | OrganizationListSearchCriteria
  | PartnerListSearchCriteria
  | ExportsListSearchCriteria
  | HandlingUnitMaterialSearchCriteria
  | MasterDataReportListSearchCriteria
  | MasterDataListSearchCriteria
  | HubListSearchCriteria
  | PlannerProfileBriefListSearchCriteria
  | Sc4FailedMessagesListSearchCriteria
  | Sc3FailedMessagesListSearchCriteria
  | CompartmentAvailableUserListSearchCriteria
  | ShipmentListSearchCriteria
  | DemurrageDetentionSearchCriteria
  | PartnerSearchCriteria
  | PlantListSearchCriteria
  | UserDeletionHistoryListSearchCriteria
  | TruckDriversSearchCriteria
  | CouplingPlanSearchCriteria
  | YardSpotSearchCriteria;

export type ListClientPaginationStateModel<ListType> = {
  items: ListType[];
} & BaseListStateModel;

export type ListServerPaginationStateModel<ListType> = ListObject<ListType> & BaseListStateModel;

export const LIST_CLIENT_PAGINATION_INITIAL_STATE = {
  items: [],
  loaded: false,
};

export const LIST_SERVER_PAGINATION_INITIAL_STATE = {
  items: [],
  size: null,
  pageNumber: null,
  numberOfElements: null,
  totalElements: null,
  totalPages: null,
  loaded: false,
};
